import { render, staticRenderFns } from "./ViewUserImages.vue?vue&type=template&id=dc827834&scoped=true"
import script from "./ViewUserImages.vue?vue&type=script&lang=js"
export * from "./ViewUserImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc827834",
  null
  
)

export default component.exports